import { json } from "react-router-dom";
import { AuthServices } from "../services/AuthServices";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import axios from "axios";

const REACT_APP_API_URL = process.env.REACT_APP_API_URL;
export const getUser = () => {
  let user = localStorage.getItem("userDetails") || "{}";
  try {
    user = JSON.parse(user);
  } catch (err) {
    user = {};
  }
  return user;
};

export const getSignUpUser = () => {
  let user = localStorage.getItem("signUpUserDetails") || "{}";
  try {
    user = JSON.parse(user);
  } catch (err) {
    user = {};
  }
  return user;
};

export const logOut = async () => {
  try {
    const res = await AuthServices.logoutuser();
    localStorage.setItem("userDetails", {});
    localStorage.setItem("signUpUserDetails", {});
    window.location.reload();
  } catch (error) {
    handleApiErrorResponses(error);
  }
};

export const logOut401 = async () => {
  // AuthServices.removeFirebaseId();
  localStorage.setItem("userDetails", {});
  localStorage.setItem("signUpUserDetails", {});
  window.location.reload();
};

export const getAuthorizationToken = (constentType) => {
  let headers = { "content-type": "application/json" };
  headers["x-auth-token"] = getUser()?.session?.token;
  if (constentType === "form-data") {
    headers["content-type"] = "multipart/form-data";
    headers["accept"] = "application/json";
  }
  return headers;
};

export const getSignUpAuthorizationToken = (constentType) => {
  let headers = { "content-type": "application/json" };
  headers["x-auth-token"] = getSignUpUser()?.session?.token;
  if (constentType === "form-data") {
    headers["content-type"] = "multipart/form-data";
    headers["accept"] = "application/json";
  }
  return headers;
};
